import React, { Component, useState, useMemo } from "react";
import DefaultDataGrid from '../components/DefaultDataGrid';
import { DataGrid, GridToolbar, plPL, getGridStringOperators, GridActionsCellItem } from '@mui/x-data-grid';
import { useParams } from 'react-router';
import { TextField, Typography, Slide, Button, Box, CircularProgress } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { Stack } from '@mui/system';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import { query, flattenObj, unflattenObject } from '../App';
import InputColumn from '../components/InputColumn'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Link } from "react-router-dom"
import DefaultSite from '../components/DefaultSite';
import AutocompleteText from '../components/AutocompleteText';
import AddIcon from '@mui/icons-material/Add';
import RowAddPage from '../components/RowAddPage';
import RowEditPage from '../components/RowEditPage';
import InputRow from '../components/InputRow';
import { OrdersDataGrid, productCellRenderer } from "./Orders";


const filterOperators = getGridStringOperators().filter(({ value }) =>
    ['equals', 'contains', 'startsWith', 'endsWith' /* add more over time */].includes(value),
);

const columns = [
    { field: 'id', headerName: 'Id', filterOperators },
    { field: 'name', headerName: 'Nazwa', minWidth: 150, flex: 1, filterOperators },
    { field: 'surname', headerName: 'Nazwisko', minWidth: 150, flex: 1, filterOperators },
    { field: 'email', headerName: 'Email', minWidth: 150, flex: 1, filterOperators },
    { field: 'mobile_phone', headerName: 'Telefon', minWidth: 150, flex: 1, filterOperators },
]
const inputColumns = {
    "Dane": [
        { type: TextField, props: { label: "Imie", name: "name" } },
        { type: TextField, props: { label: "Nazwisko", name: "surname" } },
        { type: TextField, props: { label: "Email", name: "email" } },
        { type: TextField, props: { label: "Telefon", name: "mobile_phone" } },
    ]
}
export default function Traders(props) {
    const { lookupId } = useParams();
    const [data, setData] = useState({});

    if (lookupId) return <RowEditPage title={`${(props.disableEdit ? ' Pogląd ' : 'Edycja')} handlowca o id: ${lookupId} `}
        queryPath='/traders' lookupId={lookupId} disableInputs={props.disableEdit} dataReference={setData}>
        <InputRow inputColumns={inputColumns} data={data} disabled={props.disableEdit} />
        {
            props.disableEdit && <Typography variant="h6" textAlign="left" className="container">
                Zamówienia tego handlowca:
                <OrdersDataGrid
                    filterData={{
                        field: "trader._id",
                        operator: "equals",
                        value: lookupId,
                    }}
                    components={null}
                />
            </Typography>
        }
    </RowEditPage>;
    else if (props.add) return <RowAddPage queryPath='/traders' title="Dodawanie handlowca">
        <InputRow inputColumns={inputColumns} data={{}} />;
    </RowAddPage>
    else return <DefaultDataGrid
        columns={columns}
        queryPath='/traders'
    />;
}